import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["disableButton"];

  connect() {
    console.log("connected")
  }

  disableButton() {
    if(this.hasDisableButtonTarget) {
      this.disableButtonTarget.disabled = true
    }
  }
}
